<div
  class="app-section-header"
  [class.app-section-header--first]="isFirst"
  [class.app-section-header--no-border]="noBorder"
  [ngClass]="customClass"
>
  <div class="app-section-header-content">
    <div class="app-section-header-title-row">
      <h4 class="app-section-title" *ngIf="title">{{ title }}</h4>
      <span
        *ngIf="badge"
        class="app-section-badge"
        [ngClass]="'app-section-badge--' + (badgeVariant || 'blue')"
      >
        {{ badge }}
      </span>
    </div>
    <p class="app-section-description" *ngIf="subtitle">{{ subtitle }}</p>
  </div>

  <div class="app-section-action">
    <ng-content></ng-content>
  </div>
</div>
